import React, { useEffect, useState } from 'react';
import Button from 'components/common/Button';
import './PWAUpdatePrompt.css';

const PWAUpdatePrompt = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleUpdate = (e) => {
      setWaitingWorker(e.detail.waitingWorker);
      setShow(true);
    };

    window.addEventListener('kvo:pwa-update', handleUpdate);
    return () => window.removeEventListener('kvo:pwa-update', handleUpdate);
  }, []);

  const handleRefresh = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    setShow(false);
    // The service worker will claim clients and we can reload.
    // Sometimes it's safer to listen to controllerchange, but a short timeout also works.
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const handleLater = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="kvo-pwa-update">
      <div className="kvo-pwa-update__content">
        <p>A new version of KVO is available.</p>
        <div className="kvo-pwa-update__actions">
          <Button variant="secondary" size="sm" onClick={handleLater}>Later</Button>
          <Button variant="primary" size="sm" onClick={handleRefresh}>Refresh</Button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdatePrompt;
